import { Button } from "@/components/atoms/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/atoms/Dialog";
import type { IAreYouSureDeleteReviewModalProps } from "@/components/molecules/AreYouSureDeleteReviewModal/types";
import { useTranslations } from "@/hooks/common/useTranslations";

const AreYouSureDeleteReviewModal = ({
  open,
  deleteReview,
  isLoadingDelete,
  onClose,
}: IAreYouSureDeleteReviewModalProps) => {
  const { t } = useTranslations("SingleAppPage");

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("deleteReview")}</DialogTitle>
          <DialogDescription>{t("deleteReviewDesc")}</DialogDescription>
        </DialogHeader>

        <DialogFooter className="sm:justify-start">
          <div className="flex justify-end items-end w-full gap-4">
            <Button type="button" variant="secondary" onClick={onClose}>
              {t("cancel")}
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={deleteReview}
              disabled={isLoadingDelete}
            >
              {t("delete")}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AreYouSureDeleteReviewModal;
